module.exports = __webpack_public_path__ + "img/dark-logo.c99a7c28.svg";